<script lang="ts" src="./component.ts"></script>
<style lang="scss" src="./component.scss"></style>

<template>
  <div :class="b()">
    <router-link :class="b('logo')" to="/landing">
      <span v-html="displayedLogo"></span>
    </router-link>

    <SharedLanguage view="main" />
  </div>
</template>
